module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_bg_m-108cbf0552de23e371d2062566ffe290.webp";